import type { ExpressWidgetError } from '../typings/error.types';
import { dispatchExpressErrorEvent, getErrorMessageDetails } from './index';
import Logger from './logger';
import { isStockAllocationError } from '../guards/isStockAllocationError';
import { isShippingAddressUpdateError } from '../guards/isShippingAddressUpdateError';
import { isBasketResponseError } from '../guards/isBasketResponseError';
import { isInvalidAddressDetailsError } from '../guards/isInvalidAddressDetailsError';
import { isAuthorizationError } from '../guards/isAuthorizationError';

interface HandleComponentErrorOptions {
    preventToast?: boolean;
    shouldDispatchExpressErrorEvent?: boolean;
}

const handleComponentError = (
    error: unknown,
    setExpressWidgetError: React.Dispatch<React.SetStateAction<ExpressWidgetError | null>>,
    options: HandleComponentErrorOptions = {},
) => {
    const { preventToast, shouldDispatchExpressErrorEvent } = options;
    const message = getErrorMessageDetails(error);
    Logger.showLog('error', message);

    if (isStockAllocationError(error) && !preventToast) {
        setExpressWidgetError({
            headline: 'This item is out of stock',
            message: 'Please check your basket again and review your items.',
        });
    } else if (isShippingAddressUpdateError(error) && !preventToast) {
        setExpressWidgetError({
            headline: 'There has been an issue updating your shipping address',
            message: 'Please try again or use alternate payment method.',
        });
    } else if (isBasketResponseError(error) && !preventToast) {
        const summaryError = error;
        if (summaryError.errorCode === 3) {
            setExpressWidgetError({
                headline: 'Your basket no longer has any items',
                message: 'Please refresh the page and add items to basket.',
            });
        }
    } else if (isInvalidAddressDetailsError(error) && !preventToast) {
        setExpressWidgetError({
            headline: 'Your delivery details are invalid',
            message: `${message} Please change your details in the payment provider to continue.`,
        });
    } else if (isAuthorizationError(error) && !preventToast) {
        setExpressWidgetError({
            headline: 'We could not start Express Checkout',
            message: 'Please refresh the page and try again.',
        });
    } else if (!preventToast) {
        setExpressWidgetError({
            headline: 'Something went wrong',
            message: 'Please check your basket again and review your items.',
        });
    }

    if (shouldDispatchExpressErrorEvent) {
        dispatchExpressErrorEvent<string>(message);
    }
};

export default handleComponentError;
